import { render } from "./selectLanguage.vue?vue&type=template&id=6d23a7ef&scoped=true"
import script from "./selectLanguage.vue?vue&type=script&lang=js"
export * from "./selectLanguage.vue?vue&type=script&lang=js"

import "./selectLanguage.vue?vue&type=style&index=0&id=6d23a7ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d23a7ef"]])

export default __exports__